export const perPersonLabel = "je Person"
export const perPersonPerNightLabel = "je Person je Nacht"
export const requestPriceLabel =  "Preis auf Anfrage"

export const cruise = {
  route:    "Barcelona - Cannes – Genua – La Spezia - Civitavecchia – Palma de Mallorca - Barcelona",
  date:     "17. Oktober 2026 – 24. Oktober 2026",
  ship:     "MSC Grandiosa",
  shipLink: "https://www.msccruises.de/unsere-kreuzfahrten/kreuzfahrtschiffe/msc-grandiosa",
  shippingCompanyLink: "https://www.msc-kreuzfahrten.de"
}

export const currencyFormatterLocale = { locale: 'de-DE' }

export const postServiceRecipientAgency = {
  development:  "i.am.andreas.75@gmail.com",
  production:   "info@kongress-schiffsreise.de" // change this for testing purposes, eg. with dev email
}

export const postServiceRecipientClient = {
  development: "i.am.andreas.75@gmail.com"
}

// For PHP email service to work, you need to add a @kongress-schiffsreise.de as the sender email, others email adresses will be blocked for this domain

export const postServiceFrom = {
  development:  "From: Andreas Wagner <info@kongress-schiffsreise.de>",
  production:   "From: Julia Sigglow <info@kongress-schiffsreise.de>"
}

// To show or hide early bird discounts information on the pages, declare this constant to true or false

export const showEarlyBirdInfo = false